import { render, staticRenderFns } from "./visit_page.vue?vue&type=template&id=802bb2c0&scoped=true&"
import script from "./visit_page.vue?vue&type=script&lang=js&"
export * from "./visit_page.vue?vue&type=script&lang=js&"
import style0 from "./visit_page.vue?vue&type=style&index=0&id=802bb2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802bb2c0",
  null
  
)

export default component.exports